import { Theme, css } from '@emotion/react';

export const stickyHeader = ({ zIndex }: Theme) => css`
  position: sticky;
  top: 0;
`;

export const headerBase = ({ zIndex }: Theme) => css`
  z-index: ${zIndex.header};
`;
